import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vueI18n from './i18n/i18n.js';
import { createPinia } from 'pinia';
import 'amfe-flexible/index.js';
import pixelItem from './components/pixelItem.vue';
import titleText from './components/titleText.vue';
import recordList from './components/recordList.vue';
import noRecord from './components/noRecord.vue';
import recordNav from './components/recordNav.vue';
import VueKonva from 'vue-konva';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
  Button,
  ConfigProvider,
  Toast,
  Swipe,
  SwipeItem,
  Image as VanImage,
  Popup,
  Overlay,
  Tab,
  Tabs,
  Icon,
  List,
  Notify,
  Popover,
} from 'vant';
import './assets/css/common.scss';
import './assets/css/vant.scss';
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    let token = sessionStorage.getItem('address');
    if (token) {
      next();
    } else {
      next({
        path: '/home',
      });
    }
  } else {
    next();
  }
});
AOS.init({
  aosOnce: true,
});
const app = createApp(App);
app
  .use(router)
  .use(vueI18n)
  .use(VueKonva)
  .use(createPinia())
  .use(Button)
  .use(Swipe)
  .use(ConfigProvider)
  .use(SwipeItem)
  .use(VanImage)
  .use(Popup)
  .use(Overlay)
  .use(Tab)
  .use(Tabs)
  .use(Icon)
  .use(Notify)
  .use(Toast)
  .use(Popover)
  .use(List)
  .component('pixelItem', pixelItem)
  .component('titleText', titleText)
  .component('recordList', recordList)
  .component('recordNav', recordNav)
  .component('noRecord', noRecord)
  .mount('#app');
